export default {
  "The race is coming soon. Please stay tuned for updates.":"The race is coming soon. Please stay tuned for updates.",
  "Please read the Terms & Conditions and Privacy Statement before checking the button.":
    "Please read the Terms & Conditions and Privacy Statement before checking the button.", // 协议没选
  "It's working too fast. Please try again in 10 seconds.":
    "It's working too fast. Please try again in 10 seconds.", // 10秒后才能二次验证
  "Invitation code": "Invitation code", // 1003
  "Invitation code error": "Invitation code error", // 失败提示用于else
  // 注册页开始
  Name: "Name",
  Age: "Age",
  "Please do not register if you are under 18 years old":
    "Please do not register if you are under 18 years old",
  Gender: "Gender",
  Male: "Male",
  Female: "Female",
  Other: "Prefer not to disclose",
  Email: "Email",
  "Phone number of emergency contact person":
    "Phone number of emergency contact person",
  "Please share your professional experience":
    "Please share your professional experience",
  "Previous race certificate within 3 years":
    "Previous race certificate within 3 years",
  "Your information is incorrect": "Your information is incorrect",
  "Your registration is successful. Please check more race information on your personal center.":
    "Your registration is successful. Please check more race information on your personal center.",
  "Your registration has been successfully submitted and is currently under review. Since this is a professional race, your qualification needs to undergo evaluation. Please check the status on your personal center.":
    "Your registration has been successfully submitted and is currently under review. Since this is a professional race, your qualification needs to undergo evaluation. Please check the status on your personal center.",
  // 注册页结束
  // 报名成功开始
  Pending: "Pending",
  "Congratulations!": "Congratulations!",
  // 报名成功结束
  advertisement: {
    title: "Xiaomi Smart Band 9",
    desc: "Xiaomi Smart Band 9 Introduction",
  },
  common: {
    "Personal page": "Personal Center",
    "Sign out": "Sign out",
    "Sign in": "Sign in",
    professionalRace: "Professional Race",
    runForFun: "Fun Run",
    introduction: "Introduction of Xiaomi POP Run 2024",
    termsAndCondition: "Terms & Conditions",
    privacyStatement: "Privacy Statement",
    title: "Xiaomi POP Run 2024",
    mile: "10km",
    mile2: "",
    btn: {
      confirm: "Confirm",
    },
  },
  home: {
    btn: {
      runNow: "Run Now",
    },
  },
  register: {
    disclaimer:
      "Disclaimer: Prior to engaging in the running race, please conduct a comprehensive evaluation of your physical well-being to confirm that you meet the requisite standards.",
    submit: "Submit",
  },
  details: {
    area: {
      p: "Professional Race Running time:",
      runTime: "Run for Fun Running time:",
    },
    card: {
      countdownToRegistrationStarts: "Countdown to registration",
      countdownToRegistrationEnds: "Registration ends in...",
      Days: "Days",
      Hours: "Hours",
      Minutes: "Minutes",
    },
    btn: {
      register: "Register",
      runNow: "Run Now",
      enrollmentIsFull: "Registration is full",
      registrationIsClosed: "Registration is closed",
    },
    desc: {
      invitationCodeRegistration:
        "The present period is for invitation code registration",
    },
  },
  review: {
    title: "You cannot change the operation once it has been confirmed.",
    more: "More",
    text: "Turn off reminder",
    btn: {
      agree: "Agree",
      disagree: "Disagree",
    },
  },
  end: {
    logout: "Log out",
    infoHeader: {
      title: "POP Run 2024",
      runTime: "Running Time：",
      btn: {
        runNow: "Run Now",
        pending: "Pending",
        registered: "Registered",
        rejected: "Application failed",
        waiting: "Waiting for official confirmation",
        unfortunately: "Unfortunately your application has been denied",
      },
    },
    application: "Registration Application",
    checkMore: {
      about: "Find out more here:",
    },
    participationHistory: {
      header: "Participation history",
      noHistory: "No history",
      h2: "Xiaomi Pop Run { year }-Professional Race",
    },
    share: {
      name: "Name",
      country: "Country",
      download: "Download",
      shareOn: "Share on:",
      content: "with #XiaomiPOPRun2024. Invite more people to join the race!",
      description:
        "Invite more friends to join the race and feel passion beyond limits!",
    },
  },
  footer: {
    copyright: "Copyright©2016-{year} Xiaomi.com, All Rights Reserved",
  },
  dialog: {
    logOut: {
      content: "Please check if you want to log out",
      confirm: "Confirm",
      cancle: "Cancle",
    },
    countrySelect: {
      headerTitle: "Country",
      headerContent:
        "Country-City name The following list displays the hosting cities for the Xiaomi POP Run 2024",
      rowNow: "Run Now",
      footerContent:
        "*For some countries, the registration will be redirected to an external website",
    },
  },
};
